import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import { Copy, Check } from "lucide-react";

interface CopyIdButtonProps {
  id: string;
  tooltipId?: string;
  label?: string;
}

const CopyIdButton: React.FC<CopyIdButtonProps> = ({
  id,
  tooltipId = "copy-id-tooltip",
  label = "ID",
}) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    if (!id) return;

    try {
      await navigator.clipboard.writeText(id);
      setCopied(true);
    } catch (err) {
      console.error("Failed to copy ID:", err);
    }
  };

  const handleMouseLeave = () => {
    setCopied(false);
  };

  return (
    <div className="flex items-center gap-2 group">
      <div className="text-xs text-gray-400 font-mono">
        {label}: {id}
      </div>
      <button
        onClick={copyToClipboard}
        onMouseLeave={handleMouseLeave}
        className="opacity-0 group-hover:opacity-100 transition-opacity p-1 hover:bg-gray-100 rounded"
        data-tooltip-id={tooltipId}
        data-tooltip-content={copied ? t("Copied!") : t("Copy ID")}
      >
        {copied ? (
          <Check className="w-3.5 h-3.5 text-green-500" />
        ) : (
          <Copy className="w-3.5 h-3.5 text-gray-400 hover:text-gray-600" />
        )}
      </button>
      <Tooltip id={tooltipId} />
    </div>
  );
};

export default CopyIdButton;
